module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_9006.3ff72e91.png";